var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"project-one-summary-view"}},[_c('h2',[_vm._v("ProjectOneSummaryView.vue")])])}]

export { render, staticRenderFns }